<script>
export default {
	name: 'IconSvgShare',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 16 22" :fill="color" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.75 7H3.25C2.00736 7 1 8.00736 1 9.25V18.25C1 19.4926 2.00736 20.5 3.25 20.5H12.25C13.4926 20.5 14.5 19.4926 14.5 18.25V9.25C14.5 8.00736 13.4926 7 12.25 7H10.75M10.75 4L7.75 1M7.75 1L4.75 4M7.75 1L7.75 13.75"
				stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	</div>
</template>

<style scoped>

</style>